import { useState } from "react";
import { useEffect } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";
import commonUtils from "../../helpers/commonUtils";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import OrganisationSettingActions from "../../Actions/OrganisationSettingActions";
import organisationSettingConstants from "../../Constants/OrganisationSettingConstants";
import organisationSettingStore from "../../Stores/OrganisationSettingStore";
import PlantActions from "../../Actions/PlantActions";
import AppConstants from "../../Constants/AppConstants";

const AddPlant = (props) => {
  const { plantDetails, closeEditPlantPopUpCallback, isWebsiteAdmin } = props;
  const { orgid } = props;
  const [plantName, setPlantName] = useState("");
  const [id, setId] = useState(AppConstants.DEFAULT_GUID);
  const [plantId, setPlantId] = useState("");
  const [displayCostWithPlantId, setDisplayCostWithPlantId] = useState("");
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [optionValue, setoptionValue] = useState({
    costCenterDisplay: [],
    DateFormat: [],
    TimeZone: [],
  });
  const settingName = ["DateFormat", "TimeZone", "Language"];
  const selectElement = [
    {
      label: "costCenterDisplay",
      option: optionValue.costCenterDisplay,
      translation: localization.selectCostCenterDisplay,
    },

    {
      label: "DateFormat",
      option: optionValue.DateFormat,
      translation: localization.dateFormat,
    },
    {
      label: "TimeZone",
      option: optionValue.TimeZone,
      translation: localization.timeZone,
    },
  ];
  const [orgDefaultSett, setOrgDefaultSett] = useState({
    TimeZone: "",
    costCenterDisplay: "",
    DateFormat: "",
  });
  useEffect(() => {
    OrganisationSettingActions.getOrganisationSettings();
  }, []);

  useEffect(() => {
    function getOrgSettingSuccess() {
      var res = organisationSettingStore.getOrgSettingResult();
      if (res.length > 0) {
        let previous = { ...optionValue };
        previous.costCenterDisplay = [
          { text: localization.withPlantId, value: true },
          { text: localization.withoutPlantId, value: false },
        ];
        res.map((item, index) => {
          if (settingName.includes(item.settingName)) {
            previous[item.settingName] = res[index].options;
          }
        });
        setoptionValue(previous);
      }
      setGlobalSpinner(false);
    }
    function getOrgSettingFailure() {
      setGlobalSpinner(false);
    }

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.GET_ORG_SETTING_SUCCESS,
      getOrgSettingSuccess,
    );

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.GET_ORG_SETTING_FAILURE,
      getOrgSettingFailure,
    );

    return () => {
      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.GET_ORG_SETTING_SUCCESS,
        getOrgSettingSuccess,
      );

      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.GET_ORG_SETTING_FAILURE,
        getOrgSettingFailure,
      );
    };
  }, []);

  useEffect(() => {
    if (plantDetails) {
      setId(plantDetails ? plantDetails.id : AppConstants.DEFAULT_GUID);
      setPlantId(plantDetails ? plantDetails.plantID : "");
      setPlantName(plantDetails ? plantDetails.bezeichnung : "");
      setDisplayCostWithPlantId(
        plantDetails ? plantDetails.showKostWithPlantId : "",
      );
      setOrgDefaultSett({
        DateFormat: plantDetails.dateFormat ? plantDetails.dateFormat : "",
        TimeZone: plantDetails.timeZone ? plantDetails.timeZone : "",
        costCenterDisplay: plantDetails
          ? ["yes", "sim", "ja", "oui", "lgen"].includes(
              plantDetails.showKostWithPlantId.toLowerCase(),
            )
            ? "true"
            : "false"
          : "",
      });
    }
    plantDetails ? commonUtils.setIsEdit(true) : commonUtils.setIsEdit(false);
  }, [props]);

  const plantAdd = (e) => {
    e.preventDefault();
    const plant = {
      ID: id ? id : AppConstants.DEFAULT_GUID,
      PlantID: plantId.trim(),
      Bezeichnung: plantName.trim(),
      OrganisationId: orgid,
      ShowKostWithPlantId:
        orgDefaultSett.costCenterDisplay === "true" ? true : false,
      Language: "",
      DateFormat: orgDefaultSett.DateFormat,
      TimeZone: orgDefaultSett.TimeZone,
    };
    if (isWebsiteAdmin) {
      setGlobalSpinner(true);
      PlantActions.addPlantWebAdmin(plant);
    } else {
      if (plantDetails) {
        setGlobalSpinner(true);
        PlantActions.updatePlant(plant);
      } else {
        setGlobalSpinner(true);
        PlantActions.addNewPlant(plant);
      }
    }
  };

  function handleClosePopOver() {
    setPlantName("");
    setPlantId("");
    setDisplayCostWithPlantId("");
    setOrgDefaultSett({
      language: "",
      DateFormat: "",
      costCenterDisplay: "",
      TimeZone: "",
    });
    closeEditPlantPopUpCallback();
  }
  function handleDropDown(e) {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    const previous = { ...orgDefaultSett };
    previous[name] = value;
    setOrgDefaultSett(previous);
  }
  return (
    <div
      className="modal fade"
      id="addPlantModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addPlantModal"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addPlantModal">
              {plantDetails ? localization.editplant : localization.addnewplant}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addPlantModalClose"
              onClick={handleClosePopOver}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form id="plantAdd" autoComplete="off" onSubmit={plantAdd}>
            <div className="modal-body">
              <div className="row mb-4">
                <div className="col pt-2">
                  <div className="form-outline">
                    <input
                      type="text"
                      id="addPlantId"
                      name="addPlantId"
                      className="form-control"
                      placeholder={localization.plantid}
                      required
                      maxLength={10}
                      disabled={plantDetails}
                      value={plantId}
                      onChange={(e) => {
                        e.preventDefault();
                        if (plantId !== "") {
                          setPlantId(e.target.value);
                        } else {
                          setPlantId(e.target.value.trim());
                        }
                      }}
                    />
                  </div>

                  <div className="form-outline">
                    <input
                      type="text"
                      id="addPlantName"
                      name="addPlantName"
                      className="form-control mt-4"
                      maxLength={50}
                      placeholder={localization.plantname}
                      required
                      value={plantName}
                      onChange={(e) => {
                        e.preventDefault();
                        if (plantName !== "") {
                          setPlantName(e.target.value);
                        } else {
                          setPlantName(e.target.value.trim());
                        }
                      }}
                    />
                  </div>

                  {selectElement.map((item, i) => {
                    return (
                      <div className="form-group " key={i}>
                        <select
                          className="form-control "
                          id={item.label}
                          name={item.label}
                          required={
                            item.label === "costCenterDisplay" ? true : false
                          }
                          disabled={plantDetails}
                          value={orgDefaultSett[item.label]}
                          onChange={(e) => {
                            handleDropDown(e);
                          }}
                        >
                          <option value="">
                            {item.label === "costCenterDisplay"
                              ? item.translation
                              : localization.selectDefault +
                                " " +
                                item.translation}
                          </option>
                          {optionValue[item.label].map((item, i) => {
                            return (
                              <option value={item.value} key={i}>
                                {item.text}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPlant;
